import React from "react";
import styled from "styled-components";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HeaderSvg from "../components/HeaderSvg";
import Info from "../components/mainInfo/Info";

const MainWrapper = styled.div`
  font-family: "Poppins", sans-serif;
`;

const MainInfo = () => (
  <MainWrapper>
    <HeaderSvg />
    <Header />
    <Info />
    <Footer />
  </MainWrapper>
);

export default MainInfo;
